import React from 'react';
import { object, bool, string, func, number } from 'prop-types';
import { Checkbox } from '../../../../ps-aspect-design';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { longDateString } from '../../../lib/formatters';
import Cell from '../../../Table/Cell/Cell';
import classNames from 'classnames';
import Favorite from '../ReportFavorite/ReportFavoriteContainer';
import Row from '../../../Table/Row/Row';
import { Text, Popover, Stack } from '@mantine/core';

import './ReportTableRow.scss';

ReportTableRow.propTypes = {
  category: string,
  columnCount: number,
  id: string,
  isFavorite: bool,
  location: object,
  modified: number,
  report: object,
  reportBulkSelect: func,
  scopeName: string,
  selected: bool,
  title: string,
  url: string,
  userCanSelect: bool,
  userReportViewer: bool
};

export function ReportTableRow(props) {
  const {
    category,
    createdByName,
    id,
    isFavorite,
    lastModifiedBy,
    location,
    modified,
    scopeName,
    title,
    url,
    launchDarklyFeatureFlags,
    userReportViewer,
    columnCount
  } = props;

  const rowClass = classNames({
    report__bodyrow: true,
    'report__bodyrow-selected': props.selected,
    'report__bodyrow-selectable': props.userCanSelect
  });

  const selectClass = classNames('report__row-checkbox', {
    selectable: props.userCanSelect,
    selected: props.selected
  });

  return (
    <Row className={rowClass} dataRowKey={id}>
      <Cell className="report__bodycell">
        {!userReportViewer && props.userCanSelect && (
          <div
            onClick={e => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            <Checkbox
              checked={props.selected}
              className={selectClass}
              onChange={(error, value) => {
                props.reportBulkSelect(props.report);
              }}
            />
          </div>
        )}
      </Cell>
      <Cell className="report__bodycell">
        { launchDarklyFeatureFlags && launchDarklyFeatureFlags['rw-react'] ?
          <Popover width={400} position="bottom-start" withArrow shadow="md">
            <Popover.Target>
              <Text style={{ fontSize: 16, cursor: 'pointer' }}>{title}</Text>
            </Popover.Target>
            <Popover.Dropdown>
              <Stack>
                <Link className="report__link" to={{ pathname: `/reports/${id}`, state: { history: location.pathname } }}>
                  Report Writer New
                </Link>
                <Link className="report__link" to={{ pathname: url, state: { history: location.pathname } }}>
                  Report Writer Classic
                </Link>
              </Stack>
            </Popover.Dropdown>
          </Popover> :
          <Link className="report__link" to={{ pathname: url, state: { history: location.pathname } }}>
            {title}
          </Link>
        }
      </Cell>
      <Cell className="report__bodycell">{category}</Cell>
      <Cell className="report__bodycell">{scopeName}</Cell>
      {columnCount > 5 && (
        <Cell className="report__bodycell">{scopeName === 'Standard' ? 'MarketPay' : createdByName}</Cell>
      )}
      {columnCount > 5 && (
        <Cell className="report__bodycell">{scopeName === 'Standard' ? 'MarketPay' : lastModifiedBy}</Cell>
      )}
      <Cell className="report__bodycell">{longDateString(new Date(modified))}</Cell>
      <Cell className="report__bodycell">
        <Favorite isFavorite={isFavorite} id={id} />
      </Cell>
    </Row>
  );
}

export default withRouter(ReportTableRow);
